<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  blacklists: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['delete']);

// Badges no padrão do design system (tokens n-*)
const reasonClasses = {
  optout: 'bg-n-blue-3 text-n-blue-11',
  bounce: 'bg-n-amber-3 text-n-amber-11',
  complaint: 'bg-n-ruby-3 text-n-ruby-11',
  manual: 'bg-n-alpha-2 text-n-slate-11',
  spam: 'bg-n-ruby-3 text-n-ruby-11',
  bulk_import: 'bg-n-iris-3 text-n-iris-11',
};

const { t } = useI18n();

const reasonLabel = reason =>
  t(`CAMPAIGN.BLACKLIST.REASONS.${(reason || '').toUpperCase()}`, reason);

const formatDate = date => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const formatPhone = phone => {
  if (!phone) return '-';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 13) {
    return `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 4)}) ${cleaned.slice(4, 9)}-${cleaned.slice(9)}`;
  }
  return phone;
};
</script>

<template>
  <div class="overflow-x-auto rounded-xl border border-n-weak bg-n-solid-1">
    <table class="min-w-full divide-y divide-n-weak">
      <thead>
        <tr>
          <th
            v-for="col in ['PHONE', 'REASON', 'SOURCE', 'EXPIRES', 'ADDED']"
            :key="col"
            class="px-4 py-2.5 text-left text-xs font-medium text-n-slate-10"
          >
            {{ t(`CAMPAIGN.BLACKLIST.TABLE.${col}`) }}
          </th>
          <th
            class="px-4 py-2.5 text-right text-xs font-medium text-n-slate-10"
          >
            {{ t('CAMPAIGN.BLACKLIST.TABLE.ACTIONS') }}
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-n-weak">
        <tr
          v-for="entry in blacklists"
          :key="entry.id"
          class="transition-colors hover:bg-n-alpha-1"
        >
          <td
            class="whitespace-nowrap px-4 py-3 text-sm font-medium tabular-nums text-n-slate-12"
          >
            {{ formatPhone(entry.phone_number) }}
          </td>
          <td class="whitespace-nowrap px-4 py-3 text-sm">
            <span
              class="px-2 py-0.5 text-xs font-medium rounded-full"
              :class="reasonClasses[entry.reason] || reasonClasses.manual"
            >
              {{ reasonLabel(entry.reason) }}
            </span>
          </td>
          <td class="whitespace-nowrap px-4 py-3 text-sm text-n-slate-11">
            {{ entry.source }}
          </td>
          <td class="whitespace-nowrap px-4 py-3 text-sm text-n-slate-11">
            {{
              entry.permanent
                ? t('CAMPAIGN.BLACKLIST.PERMANENT')
                : formatDate(entry.expires_at)
            }}
          </td>
          <td class="whitespace-nowrap px-4 py-3 text-sm text-n-slate-11">
            {{ formatDate(entry.created_at) }}
          </td>
          <td class="whitespace-nowrap px-4 py-3 text-right text-sm">
            <Button
              size="sm"
              variant="ghost"
              color="ruby"
              icon="i-lucide-trash-2"
              @click="emit('delete', entry)"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
